import styled from 'styled-components'

export const ContactForm = styled.form`
  margin:0 auto;
  max-width:1000px;
  position: relative;
`